import { useDispatch } from "react-redux";
import { _t } from "app/i18n/i18n";
import { setPreference, setShallowPreference } from "pages/preferences/preferencesActions";
import { switchDesign } from "pages/preferences/parts/switchDesign";
import { REDESIGN, REDESIGN_MODAL, REDESIGN_MODAL_REMIND_LATER } from "redux/slices/api/initialisePreferences";
import DesignSwitcher from "lib/DesignSwitcher/DesignSwitcher";
import { isMobile } from "lib/hooks/useIsMobile";
import "./NewDesignButton.scss";

function NewDesignButton({
  alignRight = true,
  marginLeft = 8,
  marginRight = 0,
  buttonBgColor = "#a91e1b",
  buttonBorderColor = "#9e1c19",
  pipeColor = "maroon",
  minWidth = 107,
}) {
  const dispatch = useDispatch();
  const buttonText = isMobile() ? _t("New") : _t("New Design");

  return (
    <DesignSwitcher
      alignRight={alignRight}
      buttonText={buttonText}
      onClick={() => {
        dispatch(setPreference({ key: REDESIGN, value: "New" }));
        switchDesign("New");
      }}
      infoOnClick={(e) => {
        e.stopPropagation();
        dispatch(setShallowPreference({ key: REDESIGN_MODAL, value: true }));
        dispatch(setPreference({ key: REDESIGN_MODAL_REMIND_LATER, value: false }));
      }}
      marginLeft={marginLeft}
      marginRight={marginRight}
      buttonBgColor={buttonBgColor}
      buttonBorderColor={buttonBorderColor}
      pipeColor={pipeColor}
      minWidth={minWidth}
    />
  );
}

export default NewDesignButton;
